module.exports = __webpack_public_path__ + "static/media/07.safari.df3a6c7c.svg";